(function() { window.GUID_7971afc4_8d3c_40b1_a6b9_43a82b3bfce6 = { getGuid: function() { return "7971afc4-8d3c-40b1-a6b9-43a82b3bfce6"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class PageContext {
            constructor() {
                CS.Views.PageContext.Instance = this;
            }
            static PageLoaded(controller, action, masterOverlayKey = null) {
                if (!masterOverlayKey) {
                    CS.Views.MasterPage.Instance.RefreshBody();
                }
                let pageContext = PageContext.Instance;
                let controllerAction = { controllerName: controller, actionName: action };
                if (pageContext.PageLoadedDelegates != null) {
                    for (var i = 0; i < pageContext.PageLoadedDelegates.length; i++) {
                        let delegate = pageContext.PageLoadedDelegates[i];
                        delegate.call(this, pageContext, controllerAction, masterOverlayKey);
                    }
                    pageContext.PageLoadedDelegates.length = 0; //Ceci clear la list
                }
                CS.CSS.DetermineCssFilesCountToTest();
            }
            static OnPageLoaded(controllerAction, constructorDelegate) {
                if (controllerAction == null)
                    return;
                PageContext.onPageLoaded(function (pageContext, currentControllerAction, contextKey) {
                    if (pageContext.compareNavigation(currentControllerAction, controllerAction)) {
                        constructorDelegate(contextKey);
                    }
                });
            }
            compareNavigation(currentControllerAction, controllerAction) {
                if (Array.isArray(controllerAction)) {
                    for (var i = 0; i < controllerAction.length; i++) {
                        if (this.compareNavigation(currentControllerAction, controllerAction[i]))
                            return true;
                    }
                    return false;
                }
                let currentControllerName = currentControllerAction.controllerName;
                let currentActionName = currentControllerAction.actionName;
                if (controllerAction.controllerName && controllerAction.actionName) {
                    return controllerAction.controllerName.toLowerCase() == currentControllerName && controllerAction.actionName.toLowerCase() == currentActionName;
                }
                else if (controllerAction.controllerName) {
                    return controllerAction.controllerName.toLowerCase() == currentControllerName;
                }
                else if (controllerAction.actionName) {
                    return controllerAction.actionName.toLowerCase() == currentActionName;
                }
                return false;
            }
            static onPageLoaded(delegate) {
                var pageContext = PageContext.Instance;
                if (pageContext.PageLoadedDelegates == null) {
                    pageContext.PageLoadedDelegates = new Array();
                }
                pageContext.PageLoadedDelegates.push(delegate);
            }
        }
        Views.PageContext = PageContext;
        new CS.Views.PageContext();
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=pagecontext.js.map
